import React from 'react'
import camera from './images/camera.png'
import alarm from './images/alarm-clock.png'
import battery from './images/battery.png'
import wifi from './images/wifi.png'
import silent from './images/silent.png'
import connection from './images/connection.png'
import { useState, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";

const QrCode = () => {  

  const [url, setUrl] = useState("");
  
  const qrRef = useRef();

  const downloadQRCode = (e) => {
    e.preventDefault();
    let canvas = qrRef.current.querySelector("canvas");
    let image = canvas.toDataURL("image/png");
    let anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `QR-Code.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setUrl("");
  };

  const qrCodeEncoder = (e) => {
    setUrl(e.target.value);
  };

  const qrcode = (
    <QRCodeCanvas
      id="qrCode"
      value={url}
      size={250}
      bgColor={"#fff"}
      level={"H"}
    />
  );


  const dt = () => {
    var date = new Date();
    var getHours = (date.getHours()<10?'0':'') + date.getHours();
    var getMinutes = (date.getMinutes()<10?'0':'') + date.getMinutes();
    return getHours + ":" + getMinutes 
  }
  
  return (
    <div className='container'>
      <div className='phone'>
        <div className='time'>{dt()}</div>
        <img className='camera'src={camera} alt=''/>
        <img className='icons battery' src={battery} alt=''/>
        <img className='icons' src={connection} alt=''/>
        <img className='icons wi-fi' src={wifi} alt=''/>
        <img className='icons' src={alarm} alt=''/>
        <img className='icons' src={silent} alt=''/>
        <div className='line-one'></div>
          <div className='wrapper'>
            <h1>QR CODE</h1>
              <div className='qr-code' ref={qrRef}>{qrcode}</div>
              <form onSubmit={downloadQRCode}>
                <p className='label'>Enter Your URL : </p>
                <input className='input' type="text" placeholder="URL" value={url} onChange={qrCodeEncoder} />
                <button type="submit" disabled={!url}>Download</button>
              </form>
          </div>
        <p className='credits'>Designed by <a href="https://www.ganesh-babu.online" rel="noreferrer" target="_blank">Ganesh</a></p>
        <div className='bottom-line'></div>
    </div>  
  </div>
  )
}

export default QrCode